import React, { useState } from 'react';
import { GeneralDialog } from 'sharedComponents/GeneralDialog';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { exportMessageArchiveRequest } from './actions';
import './style.scss';
import PropTypes from 'prop-types';
import { TimeSelectorRow } from 'sharedComponents/TimeSelectorRow';
import { MAX_DAYS_RANGE, MAX_DAYS_SELECTION_RANGE, PRESELECTED_DAYS } from './constants';
import { getCaptureConfig } from './helpers';

const ExportMessageArchiveComponent = ({ show, close, gatewayID, gatewaySerialNumber, gatewayType, iotDeviceId, onResetAssetInfo, asset, gatewayInformation }) => {
    const { t: translate } = useTranslation();
    const [from, setFrom] = useState();
    const [to, setTo] = useState();
    const dispatch = useDispatch();

    const handleSelectDate = (from, to) => {
        if (from && to) {
            setFrom(from);
            setTo(to);
        }
    };

    const handleExportMessageArchive = () => {
        if (!from || !to) {
            return;
        }

        // construct capture format based on gateway type
        const { captureFormat, partitionKey, dcuSerialNumber, assetId, assetSerialNumber, dcpSerialNumber } = getCaptureConfig({ gatewayType, gatewaySerialNumber, iotDeviceId, asset, gatewayInformation });
        dispatch(exportMessageArchiveRequest({
            beginTime: from,
            endTime: to,
            eventHubOrIoTEventHubEndPointName: '',
            captureFormat,
            assetId,
            assetSerialNumber,
            dcuId: gatewayID,
            dcuSerialNumber,
            partitionKey,
            dcpSerialNumber
        }));
        onResetAssetInfo();
        close();
    };

    const content = <div className='export-message-archive__content'>
        <div>{translate('ABB.Powertrain.Frontend.gatewayExportMessageArchiveDescription')}</div>
        <div className='export-message-archive__date'>
            <TimeSelectorRow
                fromDate={from}
                toDate={to}
                maxDaysBack={MAX_DAYS_RANGE}
                maxDaysRange={MAX_DAYS_SELECTION_RANGE}
                preSelectedDays={PRESELECTED_DAYS}
                minimumRequiredDaysRange={0}
                numberOfMonths={2}
                label={translate('ABB.Powertrain.Frontend.gatewayExportMessageArchiveTimeRangeLabel')}
                footerIntervalText={translate('ABB.Powertrain.Frontend.gatewayExportMessageArchiveDatePickerMax7DaysNote')}
                handleSelectDate={handleSelectDate}
                withPredefinedSelection={false}
            />
        </div>
    </div>;
    const getDeleteGatewayTitle = <h1 className='export-message-archive__title'>
        {translate('ABB.Powertrain.Frontend.gatewayExportMessageArchiveTitle')}
    </h1>;
    return (
        <GeneralDialog
            show={show}
            close={close}
            dialogClassName='export-message-archive'
            closeButton={true}
            title={getDeleteGatewayTitle}
            cancelButtonProps={{
                text: translate('ABB.Powertrain.Frontend.cancelLabel'),
            }}
            acceptButtonProps={{
                text: translate('ABB.Powertrain.Frontend.gatewayExportMessageArchiveExportLabel'),
                onClick: () => { handleExportMessageArchive(); },
            }}
            persistent={false}
        >
            {content}
        </GeneralDialog>
    );
};

ExportMessageArchiveComponent.propTypes = {
    show: PropTypes.bool,
    close: PropTypes.func,
    gatewayID: PropTypes.any,
    gatewaySerialNumber: PropTypes.string,
    gatewayType: PropTypes.string,
    onResetAssetInfo: PropTypes.func,
    asset: PropTypes.object,
    gatewayInformation: PropTypes.object,
    iotDeviceId: PropTypes.string
};

export default ExportMessageArchiveComponent;
